function sendAjax(action, data) {
  console.log('action:', action);
  console.log('data:', data);
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action,
        ...data
      },
      success: response => resolve(JSON.parse(response)),
      error: err => reject(err)
    });
  });
}

function sendAjaxUserMicro(action, data, method = 'post') {
  return new Promise((resolve, reject) => {
    var id_token = getCookie('aws_cognito_id_token');
    var form_card_message = $('.form-card-message');
    var form_ids = {
      'add-bank-account': [
        '#add-gpi-bank-account',
        '#add-slidepay-bank-account'
      ],
      'add-card': '#add-gpi-payment',
      'delete-bank-accounts': '#delete-gpi-bank-accounts',
      'delete-cards': '#delete-gpi-credit-cards'
    };
    if (id_token.length) {
      $.ajax({
        type: method,
        url: aws_api_endpoint_url + action,
        headers: {
          'Authorization': id_token
        },
        data: JSON.stringify(data),
        contentType: 'application/json',
        success: function(results) {
          console.log('Success!', results);
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_refresh_token'
            },
            success: function(results) {
              var results = JSON.parse(results);
              if (results.status === 'success') {
                console.log('Tokens refreshed!', results);
                console.log('current action:', action);
                if (action in form_ids) {
                  var parent_form = $(form_ids[action]);
                  form_card_message = $('.form-card-message', parent_form);
                }
                $(form_card_message)
                  .empty()
                  .removeClass('form-card-message-error')
                  .addClass('form-card-message-success')
                  .attr('data-cy', 'bank-account-success-message-text')
                  .text('Success!');
                setTimeout(function(){
                  location.reload(true);
                }, 250);
              } else if (results.status === 'error') {
                console.log('Tokens not refreshed?!', results);
                if (action in form_ids) {
                  var parent_form = $(form_ids[action]);
                  form_card_message = $('.form-card-message', parent_form);
                }
                $(form_card_message)
                  .empty()
                  .removeClass('form-card-message-success')
                  .addClass('form-card-message-error')
                  .attr('data-cy', 'bank-account-error-message-text')
                  .text('Something went wrong?');
              }
            },
            error: function(results) {
              console.log('Tokens refresh failed?', results);
              $(form_card_message).empty()
                .removeClass('form-card-message-success')
                .addClass('form-card-message-error')
                .attr('data-cy', 'bank-account-error-message-text')
                .text('Something went wrong?');
            }
          });
        },
        error: function(results) {
          if (action in form_ids) {
            if (action === 'add-bank-account') {
              form_card_message = $(form_ids[action].join(', ')).find('.form-card-message');
            } else {
              var parent_form = $(form_ids[action]);
              form_card_message = $('.form-card-message', parent_form);
            }
          }
          const error = results?.responseText ?? '';
          let errorMessage = 'Something went wrong?';

          if (error.includes('Invalid zip code')) {
            errorMessage = 'Invalid zip code';
          }

          if (error.includes('Account already exists')) {
            errorMessage = 'Account already exists';
          }

          if (error.includes('Invalid address')) {
            errorMessage = 'Invalid address';
          }

          if (Object.values(customErrorMessages).includes(JSON.parse(error).error) || Object.values(customDeclineErrorMessages).includes(JSON.parse(error).error)) {
            errorMessage = JSON.parse(error).error;
          }

          $(form_card_message)
            .empty()
            .removeClass('form-card-message-success')
            .addClass('form-card-message-error')
            .attr('data-cy', 'bank-account-error-message-text')
            .text(errorMessage);
          reject(errorMessage);
        }
      });
    }
  })
}
